import React, { useState, useEffect } from 'react';

const AD_SLOTS = [
  { id: 'ad-editor-top', label: 'Éditeur — bannière haute', size: '600px × 90px', realSize: '600 × 90 px', retina: '1200 × 180 px' },
  { id: 'ad-editor-sidebar-left-1', label: 'Éditeur — panneau gauche haut', size: '200px × 120px', realSize: '200 × 120 px', retina: '400 × 240 px' },
  { id: 'ad-editor-sidebar-left-2', label: 'Éditeur — panneau gauche bas', size: '200px × 120px', realSize: '200 × 120 px', retina: '400 × 240 px' },
  { id: 'ad-editor-sidebar-right', label: 'Éditeur — panneau droit', size: '200px × 300px', realSize: '200 × 300 px', retina: '400 × 600 px' },
];

const DEFAULT_CONFIG = AD_SLOTS.reduce((acc, slot) => {
  acc[slot.id] = { active: false, url: '', image: '', debug: false };
  return acc;
}, {});

export default function Admin() {
  const [authed, setAuthed] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [saved, setSaved] = useState(false);
  const [subscribers, setSubscribers] = useState(null);
  const [loadingSubscribers, setLoadingSubscribers] = useState(false);
  const [loadingAd, setLoadingAd] = useState({ active: false, name: '', slogan: '', url: '', logo: '' });

  useEffect(() => {
    fetch('/api/ad-config')
      .then(res => res.json())
      .then(data => {
        if (data['loading-ad']) setLoadingAd(data['loading-ad']);
        const adConfig = { ...DEFAULT_CONFIG };
        AD_SLOTS.forEach(slot => {
          if (data[slot.id]) adConfig[slot.id] = data[slot.id];
        });
        setConfig(adConfig);
      })
      .catch(() => {});
  }, []);

  const ADMIN_PASSWORD = '@Sicile95330';

   

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setAuthed(true);
      setError('');
      fetchSubscribers();
    } else {
      setError('Mot de passe incorrect.');
    }
  };

  const fetchSubscribers = async () => {
    setLoadingSubscribers(true);
    try {
      const res = await fetch('https://api.brevo.com/v3/contacts/lists/3', {
        headers: {
          'api-key': process.env.REACT_APP_BREVO_API_KEY,
          'Content-Type': 'application/json',
        }
      });
      const data = await res.json();
      setSubscribers(data.uniqueSubscribers || data.totalBlacklisted !== undefined ? data.uniqueSubscribers : data.totalSubscribers);
    } catch (err) {
      setSubscribers('—');
    }
    setLoadingSubscribers(false);
  };

  const updateSlot = (id, key, value) => {
    setConfig(prev => ({ ...prev, [id]: { ...prev[id], [key]: value } }));
    setSaved(false);
  };

  const handleSave = async () => {
    const fullConfig = {
      ...config,
      'loading-ad': loadingAd,
    };
    try {
      await fetch('/api/ad-config', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(fullConfig),
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
      // Relire la config depuis JSONBin pour mettre à jour l'affichage
      const res = await fetch('/api/ad-config');
      const data = await res.json();
      if (data['loading-ad']) setLoadingAd(data['loading-ad']);
      const adConfig = { ...DEFAULT_CONFIG };
      AD_SLOTS.forEach(slot => {
        if (data[slot.id]) adConfig[slot.id] = data[slot.id];
      });
      setConfig(adConfig);
    } catch (err) {
      alert('Erreur lors de la sauvegarde');
    }
  };

  const handleImageUpload = (id, file) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const maxW = 300;
      const ratio = Math.min(maxW / img.width, 1);
      canvas.width = img.width * ratio;
      canvas.height = img.height * ratio;
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      const compressed = canvas.toDataURL('image/jpeg', 0.1);
      updateSlot(id, 'image', compressed);
      URL.revokeObjectURL(url);
    };
    img.src = url;
  };

  const inputStyle = {
    width: '100%', padding: '8px 12px', border: '1px solid #2a2a2a',
    backgroundColor: '#1a1a1a', color: '#fff', fontSize: '12px',
    outline: 'none', boxSizing: 'border-box', fontFamily: 'Arial'
  };

  if (!authed) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0e0e0e', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial' }}>
      <div style={{ width: '360px' }}>
        <p style={{ color: '#FF0066', fontSize: '11px', letterSpacing: '4px', fontWeight: '700', margin: '0 0 8px', textAlign: 'center' }}>COMPIFY</p>
        <p style={{ color: '#fff', fontSize: '20px', fontWeight: '900', letterSpacing: '2px', margin: '0 0 32px', textAlign: 'center' }}>ADMIN</p>
        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <input type="password" placeholder="Mot de passe" value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ ...inputStyle, padding: '14px 16px', fontSize: '14px' }} />
          {error && <p style={{ color: '#FF0066', fontSize: '12px', margin: 0 }}>{error}</p>}
          <button type="submit" style={{ backgroundColor: '#FF0066', color: '#fff', border: 'none', padding: '14px', fontSize: '12px', letterSpacing: '2px', fontWeight: '700', cursor: 'pointer' }}>
            CONNEXION
          </button>
        </form>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0e0e0e', fontFamily: 'Arial', padding: '40px 24px' }}>
      <div style={{ maxWidth: '860px', margin: '0 auto' }}>

        {/* Header admin */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px', paddingBottom: '20px', borderBottom: '1px solid #2a2a2a' }}>
          <div>
            <p style={{ color: '#FF0066', fontSize: '11px', letterSpacing: '4px', fontWeight: '700', margin: '0 0 4px' }}>COMPIFY</p>
            <h1 style={{ color: '#fff', fontSize: '24px', fontWeight: '900', letterSpacing: '2px', margin: 0 }}>CONSOLE PUBLICITAIRE</h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '16px' }}>
              <span style={{ color: '#555', fontSize: '10px', letterSpacing: '2px' }}>INSCRITS NEWSLETTER</span>
              <span style={{ color: '#FF0066', fontSize: '24px', fontWeight: '900' }}>
                {loadingSubscribers ? '...' : subscribers !== null ? subscribers : '—'}
              </span>
              <button onClick={fetchSubscribers} style={{ backgroundColor: 'transparent', border: '1px solid #333', color: '#555', padding: '4px 8px', fontSize: '10px', cursor: 'pointer', letterSpacing: '1px' }}>
                ↻
              </button>
            </div>
          </div>
          <button onClick={handleSave} style={{
            backgroundColor: saved ? '#22c55e' : '#FF0066', color: '#fff', border: 'none',
            padding: '12px 28px', fontSize: '11px', letterSpacing: '2px', fontWeight: '700', cursor: 'pointer',
            transition: 'background-color 0.3s'
          }}>
            {saved ? '✓ SAUVEGARDÉ' : 'SAUVEGARDER'}
          </button>
        </div>

        {/* Écran de chargement publicitaire */}
        <div style={{ backgroundColor: '#1a1a1a', padding: '24px', marginBottom: '32px', border: '1px solid #2a2a2a' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <div>
              <p style={{ color: '#fff', fontSize: '14px', fontWeight: '700', margin: '0 0 4px', letterSpacing: '0.5px' }}>Écran de chargement publicitaire</p>
              <p style={{ color: '#555', fontSize: '11px', margin: 0, letterSpacing: '1px' }}>Affiché pendant la génération du PDF — 3 secondes</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#555', fontSize: '10px', letterSpacing: '1px' }}>ACTIF</span>
              <div onClick={() => {
                const updated = { ...loadingAd, active: !loadingAd.active };
                setLoadingAd(updated);
              }}
                style={{ width: '32px', height: '16px', borderRadius: '8px', cursor: 'pointer', backgroundColor: loadingAd.active ? '#22c55e' : '#333', position: 'relative', transition: 'all 0.2s' }}>
                <div style={{ position: 'absolute', top: '2px', left: loadingAd.active ? '18px' : '2px', width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#fff', transition: 'all 0.2s' }} />
              </div>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div>
              <label style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', display: 'block', marginBottom: '6px' }}>NOM DE LA MARQUE</label>
              <input style={inputStyle} placeholder="Ex: Nike, L'Oréal..." value={loadingAd.name || ''}
                onChange={e => { const updated = { ...loadingAd, name: e.target.value }; setLoadingAd(updated);   }} />
            </div>
            <div>
              <label style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', display: 'block', marginBottom: '6px' }}>SLOGAN</label>
              <input style={inputStyle} placeholder="Ex: Just Do It" value={loadingAd.slogan || ''}
                onChange={e => { const updated = { ...loadingAd, slogan: e.target.value }; setLoadingAd(updated);   }} />
            </div>
            <div>
              <label style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', display: 'block', marginBottom: '6px' }}>URL (s'ouvre en nouvel onglet)</label>
              <input style={inputStyle} placeholder="https://marque.com" value={loadingAd.url || ''}
                onChange={e => { const updated = { ...loadingAd, url: e.target.value }; setLoadingAd(updated);   }} />
            </div>
            <div>
              <label style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', display: 'block', marginBottom: '6px' }}>LOGO</label>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <input type="file" accept="image/*" id="loading-ad-logo" style={{ display: 'none' }}
                  onChange={e => {
                    if (e.target.files[0]) {
                      const file = e.target.files[0];
                      const img = new Image();
                      const url = URL.createObjectURL(file);
                      img.onload = () => {
                        const canvas = document.createElement('canvas');
                        const maxW = 100;
                        const ratio = Math.min(maxW / img.width, 1);
                        canvas.width = img.width * ratio;
                        canvas.height = img.height * ratio;
                        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
                        const compressed = canvas.toDataURL('image/jpeg', 0.3);
                        const updated = { ...loadingAd, logo: compressed };
                        setLoadingAd(updated);
                        URL.revokeObjectURL(url);
                      };
                      img.src = url;
                    }
                  }} />
                <label htmlFor="loading-ad-logo" style={{ ...inputStyle, cursor: 'pointer', color: loadingAd.logo ? '#22c55e' : '#555', textAlign: 'center' }}>
                  {loadingAd.logo ? '✓ Logo chargé' : 'Choisir un logo'}
                </label>
                {loadingAd.logo && (
                  <button onClick={() => { const updated = { ...loadingAd, logo: '' }; setLoadingAd(updated);   }}
                    style={{ backgroundColor: '#333', color: '#FF0066', border: 'none', padding: '8px 12px', cursor: 'pointer', fontSize: '12px', flexShrink: 0 }}>✕</button>
                )}
              </div>
            </div>
          </div>
          {loadingAd.logo && (
            <div>
              <label style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', display: 'block', marginBottom: '6px' }}>APERÇU LOGO</label>
              <img src={loadingAd.logo} alt="logo" style={{ maxHeight: '60px', border: '1px solid #2a2a2a', backgroundColor: '#fff', padding: '8px' }} />
            </div>
          )}
        </div>

        {/* Slots */}
        {AD_SLOTS.map((slot) => (
          <div key={slot.id} style={{ backgroundColor: '#1a1a1a', padding: '24px', marginBottom: '16px', border: '1px solid #2a2a2a' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
              <div>
                <p style={{ color: '#fff', fontSize: '14px', fontWeight: '700', margin: '0 0 4px', letterSpacing: '0.5px' }}>{slot.label}</p>
                <p style={{ color: '#555', fontSize: '11px', margin: '0 0 6px', letterSpacing: '1px' }}>{slot.id}</p>
                {/* Formats à donner à l'annonceur */}
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <div style={{ backgroundColor: '#0e0e0e', border: '1px solid #2a2a2a', padding: '4px 10px', borderRadius: '3px' }}>
                    <span style={{ color: '#888', fontSize: '9px', letterSpacing: '1px' }}>FORMAT </span>
                    <span style={{ color: '#FF0066', fontSize: '11px', fontWeight: '700', letterSpacing: '1px' }}>{slot.realSize}</span>
                  </div>
                  <div style={{ backgroundColor: '#0e0e0e', border: '1px solid #2a2a2a', padding: '4px 10px', borderRadius: '3px' }}>
                    <span style={{ color: '#888', fontSize: '9px', letterSpacing: '1px' }}>RETINA </span>
                    <span style={{ color: '#555', fontSize: '11px', fontWeight: '700', letterSpacing: '1px' }}>{slot.retina}</span>
                  </div>
                  <span style={{ color: '#333', fontSize: '9px', letterSpacing: '1px' }}>JPG / PNG</span>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                {/* Debug toggle */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ color: '#555', fontSize: '10px', letterSpacing: '1px' }}>DEBUG</span>
                  <div onClick={() => updateSlot(slot.id, 'debug', !config[slot.id].debug)}
                    style={{ width: '32px', height: '16px', borderRadius: '8px', cursor: 'pointer', backgroundColor: config[slot.id].debug ? '#FF0066' : '#333', position: 'relative', transition: 'all 0.2s' }}>
                    <div style={{ position: 'absolute', top: '2px', left: config[slot.id].debug ? '18px' : '2px', width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#fff', transition: 'all 0.2s' }} />
                  </div>
                </div>
                {/* Actif toggle */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ color: '#555', fontSize: '10px', letterSpacing: '1px' }}>ACTIF</span>
                  <div onClick={() => updateSlot(slot.id, 'active', !config[slot.id].active)}
                    style={{ width: '32px', height: '16px', borderRadius: '8px', cursor: 'pointer', backgroundColor: config[slot.id].active ? '#22c55e' : '#333', position: 'relative', transition: 'all 0.2s' }}>
                    <div style={{ position: 'absolute', top: '2px', left: config[slot.id].active ? '18px' : '2px', width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#fff', transition: 'all 0.2s' }} />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', display: 'block', marginBottom: '6px' }}>URL ANNONCEUR</label>
                <input style={inputStyle} placeholder="https://annonceur.com" value={config[slot.id].url}
                  onChange={e => updateSlot(slot.id, 'url', e.target.value)} />
              </div>
              <div>
                <label style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', display: 'block', marginBottom: '6px' }}>BANNIÈRE IMAGE</label>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <input type="file" accept="image/*" id={`img-${slot.id}`} style={{ display: 'none' }}
                    onChange={e => { if (e.target.files[0]) handleImageUpload(slot.id, e.target.files[0]); }} />
                  <label htmlFor={`img-${slot.id}`} style={{ ...inputStyle, cursor: 'pointer', color: config[slot.id].image ? '#22c55e' : '#555', textAlign: 'center' }}>
                    {config[slot.id].image ? '✓ Image chargée' : 'Choisir une image'}
                  </label>
                  {config[slot.id].image && (
                    <button onClick={() => updateSlot(slot.id, 'image', '')}
                      style={{ backgroundColor: '#333', color: '#FF0066', border: 'none', padding: '8px 12px', cursor: 'pointer', fontSize: '12px', flexShrink: 0 }}>✕</button>
                  )}
                </div>
              </div>
            </div>

            {/* Aperçu image */}
            {config[slot.id].image && (
              <div style={{ marginTop: '12px' }}>
                <label style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', display: 'block', marginBottom: '6px' }}>APERÇU</label>
                <img src={config[slot.id].image} alt="aperçu" style={{ maxWidth: '100%', maxHeight: '90px', objectFit: 'cover', border: '1px solid #2a2a2a' }} />
              </div>
            )}
          </div>
        ))}

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '32px', paddingTop: '20px', borderTop: '1px solid #2a2a2a' }}>
          <button onClick={handleSave} style={{
            backgroundColor: saved ? '#22c55e' : '#FF0066', color: '#fff', border: 'none',
            padding: '14px 48px', fontSize: '11px', letterSpacing: '3px', fontWeight: '700', cursor: 'pointer'
          }}>
            {saved ? '✓ SAUVEGARDÉ' : 'SAUVEGARDER TOUS LES CHANGEMENTS'}
          </button>
          <p style={{ color: '#333', fontSize: '10px', margin: '12px 0 0', letterSpacing: '1px' }}>
            Les changements sont sauvegardés localement dans ce navigateur.
          </p>
        </div>

      </div>
    </div>
  );
}